import _ = require("lodash");
import { AssetClassPerformance } from "../portfolio/models/aggregatePortfolioItem";
import { defaultAssetClassNames } from "../portfolioadmin/models/PortfolioAttributionBenchmarkDto ";

export const getNegativeBarGraphOptions = (
  attribution: AssetClassPerformance[]
) => {
  let total =
    Math.round(
      (_.sumBy(attribution, (item) =>
        parseFloat(
          ((item.performance - item.benchmarkPerformance) * 100).toFixed(2)
        )
      ) +
        Number.EPSILON) *
        100
    ) / 100;
  let performance = [{ value: total, itemStyle: { color: "#097896" } }];
  let offsetValues = [0];
  const columnLabels = attribution
    .map((x) => {
      let label = x.name;
      let assetClassName = defaultAssetClassNames.find(
        (n) => n.longName == x.name
      );

      if (!!assetClassName) {
        label = assetClassName.shortName;
      }
      return label;
    })
    .reverse();
  columnLabels.push("PORTFOLIO");

  for (let item of attribution) {
    if (item.performance - item.benchmarkPerformance < 0) {
      let bc = new StyleOption(
        parseFloat(
          ((item.performance - item.benchmarkPerformance) * 100).toFixed(2)
        )
      );
      performance.push({
        ...bc,
        value: parseFloat(
          ((item.performance - item.benchmarkPerformance) * 100).toFixed(2)
        ),
      });
      offsetValues.push(total);
    } else {
      let bc = new StyleOption(
        parseFloat(
          ((item.performance - item.benchmarkPerformance) * 100).toFixed(2)
        )
      );
      performance.push(bc);
      total -= parseFloat(
        ((item.performance - item.benchmarkPerformance) * 100).toFixed(2)
      );
      offsetValues.push(total);
    }
  }

  let option = {
    tooltip: {
      trigger: "axis",
      axisPointer: {
        type: "shadow",
      },
    },
    grid: {
      left: "3%",
      right: "4%",
      bottom: "3%",
      containLabel: true,
    },
    xAxis: [
      {
        type: "value",
      },
    ],
    yAxis: [
      {
        type: "category",
        axisTick: {
          show: false,
        },
        data: columnLabels,
      },
    ],
    series: [
      {
        name: "Asset Class",
        type: "bar",
        label: {
          show: true,
          position: "inside",
        },
        emphasis: {
          focus: "series",
        },
        data: performance.reverse(),
      },
    ],
  };

  return option;
};

export class StyleOption {
  value: number;
  itemStyle: ChartStyle;

  constructor(value: number) {
    this.value = value;
    let color: string = value > 0 ? "#b2d979" : "#ed432c";
    this.itemStyle = new ChartStyle(color);
  }
}

export class ChartStyle {
  color: string;
  constructor(color: string) {
    this.color = color;
  }
}



// WEBPACK FOOTER //
// ./src/app/common/negative-bar-graph-options.ts